// src/pages/useUserServices.ts
import api from '@/services/api'
import { API_ENDPOINTS, MerchantTzApi, UserSecurityApi } from '@myorg/type-lib'
import { type MerchantKeysApi, type MerchantKeysPayload } from '@myorg/type-lib'

// 導出 Blog 相關邏輯
export const blogApi = {
  fetchPosts: async (page: number, size: number) => {
    const res = await api().get(API_ENDPOINTS.BLOG.GET_POSTS, {
      params: { page, size }
    })
    return res.data
  },
  createPost: async (title: string, content: string) => {
    const res = await api().post(API_ENDPOINTS.BLOG.POSTS, {
      title,
      content
    })
    return res.data
  },
  addComment: async (postId: string, content: string) => {
    // 執行函式取得正確的 URL 字串
    const url = API_ENDPOINTS.BLOG.COMMENTS(postId);
    
    await api().post(url, {
      content
    });
  },
  deletePost: async (postId: string) => {
    await api().delete(`${API_ENDPOINTS.BLOG.POSTS}/${postId}`)
  }
}

// 導出 Account 相關邏輯
export const accountApi = {
  changePassword: async (passwordData: any) => {
    const res = await api().patch(API_ENDPOINTS.ACCOUNT.CHANGE_PASS, passwordData)
    return res.data
  },
  getUsersByMerchant: async () => {
    // Note: X-User-Merchant-Id is handled by your axios interceptor 
    // or set globally in the request.
    const res = await api().get(API_ENDPOINTS.USER_INFO.ME)
    return res.data.data // Matches the Go { status: "success", data: { ... } } structure
  },
  updateUserStatus: async (username: string, enabled: boolean) => {
    // This matches: PathUserEnabled = "/users/:username/status"
    // Assuming your base API path handles the "/api/auth" prefix
    const res = await api().patch(API_ENDPOINTS.USER_INFO.STATUS(username), {
      enabled: enabled
    })
    return res.data
  }
}


// 導出 Account 相關邏輯
export const tzApi: MerchantTzApi = {
  getMerchantTz: async () => {
    // 從 localStorage 取得 merchantId
    const merchantId = localStorage.getItem('merchantId')

    if (!merchantId) {
      throw new Error('Merchant ID not found in storage')
    }
    const url = API_ENDPOINTS.MENU.TIMEZONE_GET.replace(':id', merchantId);
    const res = await api().get(url);
    const tz = res.data.tz || 'UTC'
    localStorage.setItem('merchant_tz', tz)
    return res.data
  },
  // 更新時區至後端 (對應 Go 的 UpdateMerchantTz)
  updateMerchantTz: async (tz: string) => {
    const payload = { tz: tz };
    const res = await api().patch(API_ENDPOINTS.MENU.TIMEZONE, payload)
    localStorage.setItem('merchant_tz', tz)
    return res.data
  },

  getMerchantInfo: async (merchantId:string) => {
    const res = await api().get(API_ENDPOINTS.MENU.MERCHANT_INFO_GET.replace(':merchant_id', merchantId))
    return res.data
  },
  updateMerchantInfo: async (merchantName: string, memo1: string, memo2: string) => {
    const payload = {
      merchant_name: merchantName,
      memo1: memo1,
      memo2: memo2
    }
    const res = await api().patch(`/api/menu/merchant-info`, payload)
    return res.data
  },
}

export const userSecurityApiImpl: UserSecurityApi = {
  requestAccountDeletion: async () => {
    // 呼叫你剛剛在 Go 實作的路由
    const res = await api().post('/api/auth/delete/request')
    return res.data
  }
}

export const merchantKeysApiImpl : MerchantKeysApi = {
  saveMerchantKeys: async (payload: MerchantKeysPayload) => {
    // 依據規格發送 POST 請求
    const res = await api().post('/api/ecpay-helper/merchant/keys', payload);
    return res.data
  },
}
